import { Grid, GridProps } from "shared/components/Spor";
import { FCWC } from "shared/utils/FCWC";

type SubgridProps = {
  fullWidth?: boolean;
  fullHeight?: boolean;
};

export const Subgrid: FCWC<SubgridProps & GridProps> = ({
  fullHeight = false,
  fullWidth = true,
  children,
  ...rest
}) => (
  <Grid
    templateColumns="subgrid"
    gridColumn={fullWidth ? "1 / -1" : undefined}
    gridRow={fullHeight ? "1 / -1" : undefined}
    {...rest}
  >
    {children}
  </Grid>
);
